import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import "./style.less";

const isNightsCalendarEnabled = true;

const InputFloatLabel = ({
  label,
  className,
  inputClassName,
  error,
  noBorder,
  floatLabelByDefault,
  value: valueFromProps,
  onChange: onChangeFromProps,
  suffixIcon,
  setIsFocus,
  uppercase,
  viewRateBlock,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const [value, setValue] = useState(valueFromProps);

  const onFocus = () => {
    setIsActive(true);
    if (setIsFocus) setIsFocus(true);
  };

  const onBlur = () => {
    if (!value) {
      setIsActive(false);
    }
    if (setIsFocus) setIsFocus(false);
  };

  const onChange = (e) => {
    setValue(e.target.value);

    if (onChangeFromProps) {
      onChangeFromProps(e);
    }
  };

  useEffect(() => {
    if (value || valueFromProps) {
      setIsActive(true);
      if (typeof valueFromProps === "string") setValue(valueFromProps);
    }
  }, [value, valueFromProps]);

  return (
    <>
      <div
        className={cn(
          "relative bg-white",
          {
            "border-red-error": error,
            "border border-solid border-gray-med rounded-sm": !noBorder,
            "fixed-label-position": floatLabelByDefault,
          },
          className
        )}>
        <label
          htmlFor={rest.name}
          className={cn("input-float-label", {
            "text-10 leading-12 top-6 text-gold": isActive,
            "text-14 top-12 text-gray-dark": !isActive,
            "!top-14": viewRateBlock || isNightsCalendarEnabled,
          })}>
          {label}
        </label>
        <input
          id={rest.name}
          type="text"
          className={cn(
            "input-float-box truncate p-10 rounded-sm",
            {
              "pr-28": suffixIcon,
              "pt-20 pb-8 pr-12": isActive,
              uppercase: uppercase,
              "!pt-30 !px-10 !pb-10": viewRateBlock || isNightsCalendarEnabled,
            },
            inputClassName
          )}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...rest}
        />
        {suffixIcon && (
          <div className="absolute flex items-center bottom-10 right-0 top-20 mr-6">
            {suffixIcon}
          </div>
        )}
      </div>

      {Boolean(error) && (
        <span className="block mt-6 font-mulish text-12 leading-20 text-red-error">
          {error}
        </span>
      )}
    </>
  );
};

InputFloatLabel.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
};

InputFloatLabel.defaultProps = {
  value: "",
};

export default InputFloatLabel;
